<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Daftar Tagihan</li>
              </ol>
            </div>
            <h4 class="page-title">Daftar Tagihan</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <!-- <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <label for="">Tanggal Penetapan</label>
                    <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                </div>
                <div class="col-12 col-md-3">
                    <label for="">Tanggal Pelimpahan</label>
                    <date-picker required style="width: 100%" v-model="filter.pay_date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                </div>
                <div class="col-12 col-md-3">
                    <label for="">Status</label>
                    <select name="" id="" class="form-control" v-model="filter.status">
                        <option :value="null">Semua Status</option>
                        <option value="SUCCESS">Sukses</option>
                        <option value="PENDING">Menunggu Pembayaran</option>
                        <option value="WAITING_PROCESS">Menunggu Persetujuan</option>
                        <option value="EXPIRED">Expired</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <div style="margin-top: 25px; float: right">
                        <button class="btn btn-primary" @click="loadData">Filter</button>
                        <div class="btn-group ml-2">
                            <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Export Data
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click.prevent="exportData('pdf')">PDF</a>
                                <a class="dropdown-item" @click.prevent="exportData('excel')">EXCEL</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="wrapper-table-default">
                <div class="d-flex justify-content-between">
                    <div>
                        <div v-if="companyType == 'HEALTH_CARE'">
                            <router-link 
                            v-if="$store.state.userData.company.is_transaction == 1 && userType != 'COMPANY OPERATOR'"
                            :to="{ name: 'instanceTransactionCreate' }" class="btn btn-success waves-effect waves-light left-action">Tambah Tagihan </router-link>
                        </div>

                        <div v-else>
                            <router-link 
                            v-if="$store.state.userData.company.is_transaction == 1"
                            :to="{ name: 'instanceTransactionCreate' }" class="btn btn-success waves-effect waves-light left-action">Tambah Tagihan </router-link>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-warning waves-effect waves-light mr-3" @click="exportTemplateTransaction">Download Template Transaksi</button>
                        <button class="btn btn-info waves-effect waves-light" @click="$refs.import_trx.click()">Import Transaksi</button>
                        <input type="file" accept=".xlsx" style="display: none" ref="import_trx" @change="importTransaction">
                    </div>
                </div>

                <button type="button" class="btn btn-primary float-right" @click.prevent="loadData(paging.current_page)">
                    <i class="fas fa-sync-alt"></i>
                </button>
                <div class="table-responsive">
                    <table id="table-default" class="table table-w-paginate table-bordered table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Nama / Invoice Code</th>
                                <th class="text-center">Tanggal Penetapan</th>
                                <th class="text-center">Kategori Retribusi</th>
                                <th class="text-center">Status</th>
                                <th class="text-right">Total</th>
                                <th style="width: 200px">Aksi</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.name" @input="onSearch"></th>
                                <th style="padding: 0px; !important">
                                    <date-picker style="width: 100%" v-model="search.invoice_date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" @change="onSearch"></date-picker>
                                    <!-- <input type="text" class="form-control" placeholder="Cari ..." v-model="search.invoice_date" @input="onSearch"> -->
                                </th>
                                <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.service_name" @input="onSearch"></th>
                                <th style="padding: 0px; !important">
                                    <select name="" id="" class="form-control" @change="onSearch" v-model="search.status">
                                        <option value="SUCCESS">Sukses</option>
                                        <option value="PENDING">Menunggu Pembayaran</option>
                                        <option value="WAITING_PROCESS">Menunggu Persetujuan</option>
                                        <option value="WAITING_CONFIRMATION">Menunggu Konfrimasi</option>
                                        <option value="EXPIRED">Expired</option>
                                    </select>
                                </th>
                                <!-- <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.status" @input="onSearch"></th> -->
                                <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.total" @input="onSearch"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataTransaction" :key="item.id">
                                <td>
                                    <span style="font-weight:bold; color: #000" v-if="item.customer">
                                    {{ item.customer.name ? item.customer.name : ''  }}
                                    <span v-if="item.customer.customer_code">({{item.customer.customer_code}})</span>
                                    </span><br v-if="item.customer">
                                    <span> {{ item.invoice_code }}</span>
                                </td>
                                <td class="text-center">{{ convertDate(item.invoice_date) }}</td>
                                <td class="text-center">
                                    <span v-for="(service, index) in item.service_name" :key="service+index">
                                        {{service}}
                                        <template v-if="index != item.service_name.length - 1">, </template>
                                    </span>
                                </td>

                                <td class="text-right">
                                    <GetStatusInTable :data="item"></GetStatusInTable>
                                </td>

                                <td class="text-right">{{ currency(item.total) }}</td>
                                <td>
                                    <div class="dropdown">
                                        <button class="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            :disabled="loadingDownloadPDF">
                                            <div class="spinner-border" role="status" v-if="loadingDownloadPDF">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <span v-else>Lakukan Aksi <i style="font-size: 12px; margin-left: 10px;" class="fas fa-chevron-down"></i> </span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <template v-if="companyType == 'HEALTH_CARE' && item.status == 'WAITING_CONFIRMATION'">
                                                <router-link class="dropdown-item" :to="{name: 'instanceTransactionEdit', params: {id: item.id}}"><i class="fas fa-pen"></i> Edit</router-link>
                                            </template>

                                            <!-- IS EDITABLE KETIKA MENUNGGU PEMBAYARAN -->
                                            <template v-if="item.is_editable">
                                                <a class="dropdown-item" href="#!" 
                                                v-if="item.status == 'WAITING_PROCESS' && $store.state.permission.includes('transaction.update')"
                                                @click.prevent="loadProcess(item.id)"><i class="fas fa-book"></i> Terbitkan Tagihan</a>

                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS'" @click.prevent="$refs.detailTransaction.loadDetail(item.id)"><i class="fas fa-eye"></i> Detail</a>
                                                
                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS'" @click.prevent="getPDF(item.id, item.invoice_code, 'SKRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak {{ companyType == 'HEALTH_CARE' ? 'Tagihan' : 'SKRD'}}
                                                </a>

                                                <a class="dropdown-item" href="#!" v-if="item.status != 'WAITING_PROCESS' && item.penalty" @click.prevent="getPDF(item.id, item.invoice_code, 'STRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak STRD
                                                </a>

                                                <a class="dropdown-item" @click.prevent="cancelTransaction(item.id, item.invoice_code)" 
                                                    v-if="
                                                        (userType == 'COMPANY SUPERADMIN' || userType == 'HEALTH CARE ADMIN')
                                                        && companyType == 'HEALTH_CARE' 
                                                        && item.is_canceled == 0 
                                                        &&
                                                        (
                                                            (item.payment_method == 'QRIS_STATIC' || item.payment_method == 'TUNAI')
                                                            ||
                                                            ((item.payment_method == 'BPD' || item.payment_method == 'QRIS') && item.status != 'SUCCESS')
                                                        ) && item.status != 'WAITING_PROCESS'
                                                        "
                                                    href="#">
                                                    <i class="fas fa-times"></i> 
                                                    Batalkan Transaksi
                                                </a>
                                            </template>

                                            <template v-else>
                                                <a class="dropdown-item" href="#!" @click.prevent="$refs.detailTransaction.loadDetail(item.id)"><i class="fas fa-eye"></i> Detail</a>

                                                <a class="dropdown-item" href="#!" 
                                                    v-if="
                                                    (item.status == 'PENDING' || item.status == 'SUCCESS') 
                                                    && $store.state.permission.includes('transaction.update') 
                                                    && $store.state.userData.company.is_has_unit"
                                                    @click.prevent="loadProcess(item.id)"><i class="fas fa-pen"></i> Edit Tanda Tangan
                                                </a>

                                                <a class="dropdown-item" href="#!" @click.prevent="getPDF(item.id, item.invoice_code, 'STS')" v-if="companyType == 'HEALTH_CARE' && item.status != 'SUCCESS'">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak Tagihan
                                                </a>

                                                <a class="dropdown-item" href="#!" @click.prevent="getPDF(item.id, item.invoice_code, 'STS-SUCCESS')" v-if="companyType == 'HEALTH_CARE' && item.status == 'SUCCESS'">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak Bukti Pembayaran
                                                </a>

                                                <a class="dropdown-item" href="#!" @click.prevent="getPDF(item.id, item.invoice_code, 'SKRD')"  v-if="companyType == 'OTHER'">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak SKRD
                                                </a>

                                                <a class="dropdown-item" href="#!" v-if="item.penalty" @click.prevent="getPDF(item.id, item.invoice_code, 'STRD')">
                                                    <i class="fas fa-print"></i> 
                                                    Cetak STRD
                                                </a>

                                                <!-- && $store.state.permission.includes('transaction.cancel')  -->
                                                <!-- ((item.payment_method == 'BPD' || item.payment_method == 'QRIS') && (item.status == 'PENDING' || item.status == 'WAITING_PROCESS')) -->

                                                            <!-- (item.payment_method == 'QRIS_STATIC' || item.payment_method == 'TUNAI')
                                                            || -->
                                                <a class="dropdown-item" @click.prevent="cancelTransaction(item.id, item.invoice_code)" 
                                                    v-if="
                                                        (userType == 'COMPANY SUPERADMIN' || userType == 'HEALTH CARE ADMIN')
                                                        && companyType == 'HEALTH_CARE' 
                                                        && item.is_canceled == 0 
                                                        &&
                                                        (
                                                            (item.payment_method == 'QRIS_STATIC' || item.payment_method == 'TUNAI')
                                                            ||
                                                            ((item.payment_method == 'BPD' || item.payment_method == 'QRIS') && item.status != 'SUCCESS')
                                                        )
                                                        "
                                                    href="#">
                                                    <i class="fas fa-times"></i> 
                                                    Batalkan Transaksi
                                                </a>
                                            </template>

                                            <a class="dropdown-item" href="#"
                                                v-if="$store.state.permission.includes('transaction.delete')"
                                             @click.prevent="deleteItem(item.status, item.id, item.invoice_code)"><i class="fas fa-trash"></i> Hapus</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="clearfix mt-3">
                    <div class="float-right">
                        <paginate 
                            v-model="paging.currentPage"
                            :page-count="paging.rows" :page-range="3" :margin-pages="2" :click-handler="paginate"
                            :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-link'" :next-class="'page-link'"
                            :container-class="'pagination mb-0'" :page-link-class="'page-link'" :page-class="'page-item'" align="right">
                        </paginate>
                    </div>
                </div>
            </div>
          </div>
      </div>
      
    <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <detail-transaction ref="detailTransaction"></detail-transaction>
        </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import { debounce } from "debounce"

export default {
    data() {
        return {
            loading: true,
            loadingDownloadPDF: false,

            loadingExport: false,

            paging:{
                rows: 0,
                currentPage: 1,
                perPage: 10,
                total: 0,
                to: 0,
            },

            search: {
                name: null,
                invoice_date: null,
                service_name: null,
                status: null,
                total: null,
            },

            filter: {
                date: [null,null],
                pay_date: [null, null],
                status: null,
            },
            dataTransaction: [],
        }
    },
    components: {
        DatePicker
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        loadProcess(id) {
            this.$router.push({ name: 'instanceTransactionProcess', params: { id: id } })
        },
        exportTemplateTransaction(){
            this.$http.post(`${this.API_URL}transaction/import/generate-template`,
                {

                },
                {
                    responseType: 'blob',
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                }
            )
            .then(response => {
                this.sAlert('success', 'Berhasil import data!')
                fileDownload(response.data, 'template-transaksi.xlsx')
            })
            .catch(error => {
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }) 
        },
        importTransaction(){
            const formData = new FormData
            formData.append('file', this.$refs.import_trx.files[0])

            this.$http.post(`${this.API_URL}transaction/import/excel`,
                formData,
                {
                    responseType: 'blob',
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                }
            )
            .then(response => {
                this.sAlert('success', 'Berhasil import data!')
                this.loadData()
            })
            .catch(error => {
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }) 
        },
        async cancelTransaction(id, trxCode){
            const { value: text } = await Swal.fire({
                title: 'Apakah anda yakin untuk membatalkan transaksi?',
                input: 'text',
                inputPlaceholder: 'Masukkan Kode Transaksi',
                showCancelButton: true,
                confirmButtonText: 'Ya, Batalkan Transaksi!',
                html: `
                Masukkan <b>${trxCode}</b> pada kolom dibawah untuk konfirmasi batalkan transaksi!
                `,
                inputValidator: (value) => {
                    if (value != trxCode) {
                        return 'Kode yang anda masukkan salah, coba lagi!'
                    }
                }
            })

            if (text == trxCode) {
                this.loading = true
              
                this.$http({
                    method: 'POST',
                    url: `${this.API_URL}transaction/cancel/${id}`,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(() => {
                    this.loadData()
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        },
        getPDF(id, invoice_code, type) {
            this.loadingDownloadPDF = true

            let url, filename
            if(type == 'SKRD') {
                url = `transaction/${id}/pdf`
                filename = `SKRD-${invoice_code}-${Date.now()}.pdf`
            }else if(type == 'STRD'){
                url = `transaction/${id}/pdf?type=STRD`
                filename = `STRD-${invoice_code}-${Date.now()}.pdf`
            }else if(type == 'STS'){
                url = `transaction/${id}/pdf`
                filename = `TAGIHAN-${invoice_code}-${Date.now()}.pdf`
            }else if(type == 'STS-SUCCESS'){
                url = `transaction/${id}/pdf?type=success`
                filename = `BUKTI-PEMBAYARAN-${invoice_code}-${Date.now()}.pdf`
            }

            this.$http.get(`${this.API_URL}${url}`, {
                responseType: 'blob',
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                }
            })
            .then(response => {
                this.loadingDownloadPDF = false
                fileDownload(response.data, filename);
            })
            .catch(error => {
                this.loadingDownloadPDF = false
                console.error(error);
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            })
        },
        paginate(page){
            this.$router.push({
                name: 'instanceTransaction',
                query: {
                    // keywords: null,
                    page: page,
                }
            })

            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;

            this.loadData(page)
        },
        onSearch() {
            this.searchHeader(this);
        },
        searchHeader: debounce(async (vm) => {
            vm.loadData(1)
        }, 1500),
        loadData(page) {

            this.loading = true;
            
            this.$http.get(`${this.API_URL}transaction`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` },
                params: {
                    page: page ? page : this.$route.query.page,
                    name: this.search.name,
                    invoice_date: this.search.invoice_date ? this.convertSentDate(this.search.invoice_date) : null,
                    service_name: this.search.service_name,
                    status: this.search.status,
                    total: this.search.total,
                }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                if(result.success) {
                    this.dataTransaction = result.data.data
                    this.paging.rows = result.data.last_page
                    this.paging.currentPage = result.data.current_page
                    this.paging.perPage = result.data.per_page
                    this.paging.total = result.data.total
                    this.paging.to = result.data.to

                    setTimeout(() => {
                        // this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        async exportData(type) {
            this.loadingExport = true;
            try {
                let storedData = {
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    status: this.filter.status,
                    start_pay_date: this.filter.date[0] ? moment(this.filter.pay_date[0]).format('YYYY-MM-DD') : null,
                    end_pay_date: this.filter.date[1] ? moment(this.filter.pay_date[1]).format('YYYY-MM-DD') : null,
                    export: 1,
                    export_type: type
                }

                const response = await this.$http.get(`${this.API_URL}transaction`, {
                    responseType: 'blob',
                    params: storedData,
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })

                const typeData = type == 'pdf' ? '.pdf' : '.xlsx'
                fileDownload(response.data, 
                `Laporan Transaksi${this.filter.company ? '-' + this.allCompany.find(item => item.id == this.filter.company).name : ''}${this.filter.date[0] ? '-' + this.filter.date[0] : ''}${this.filter.date[1] ? '-' + this.filter.date[1] : ''}${typeData}`);
                this.loadingExport = false

            } catch (error) {
                console.log(error);
                this.loadingExport = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async deleteItem(status, id, trxCode){
            const { value: text } = await Swal.fire({
                title: status == 'SUCCESS' ? 'Data tagihan sudah berstatus <b>sukses</b>,<br> apakah anda yakin untuk menghapus?' : 'Apakah anda yakin untuk menghapus?',
                input: 'text',
                inputPlaceholder: 'Masukkan Kode Transaksi',
                showCancelButton: true,
                confirmButtonText: 'Ya, Hapus!',
                html: `
                Masukkan <b>${trxCode}</b> pada kolom dibawah untuk konfirmasi hapus data!
                `,
                inputValidator: (value) => {
                    if (value != trxCode) {
                        return 'Kode yang anda masukkan salah, coba lagi!'
                    }
                }
            })

            if (text == trxCode) {
                this.loading = true
                    this.$http.delete(`${this.API_URL}transaction/delete/${id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(() => {
                    this.loadData()
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>